// extracted by mini-css-extract-plugin
export default {"overallRatingButton":"JO8_V"};